<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Add participant</h2>
  <p class="dialog-subtitle">Invite an approved company to join this project.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline" class="company-field">
    <mat-label>Company</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      [(ngModel)]="selection"
      name="selection"
      [matAutocomplete]="auto"
      placeholder="Search by name or registration no."
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompany" panelClass="participant-autocomplete-panel">
      @for (c of filteredCompanies; track c.id) {
        <mat-option [value]="c">
          <div class="company-option">
            <span class="company-option__avatar">{{ c.name.charAt(0) }}</span>
            <div class="company-option__text">
              <span class="company-option__name">{{ c.name }}</span>
              <span class="company-option__meta">{{ c.registrationNo }} · {{ c.countryCode }}</span>
            </div>
          </div>
        </mat-option>
      } @empty {
        <mat-option disabled class="no-match-option">No matching companies found.</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <p class="field-status">
    @if (isLoadingCompanies()) {
      Loading companies…
    } @else if (companies().length === 0) {
      No other approved companies available to add.
    } @else {
      {{ companiesHint }}
    }
  </p>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Adding…' : 'Add participant' }}
  </button>
</mat-dialog-actions>